import { Appointment } from "@elixir/types";
import SaQuestionnaireStatus from "./sa-questionnaire-status";

const SaStatusWrapper = ({
  apt,
  className = "dr-col-span-2",
}: {
  apt: Appointment;
  className?: string;
}) => {
  return <SaQuestionnaireStatus apt={apt} className={className} />;
};

export default SaStatusWrapper;
